import { render, staticRenderFns } from "./NoticePopupContent.vue?vue&type=template&id=5faca2de"
import script from "./NoticePopupContent.vue?vue&type=script&lang=js"
export * from "./NoticePopupContent.vue?vue&type=script&lang=js"
import style0 from "./NoticePopupContent.vue?vue&type=style&index=0&id=5faca2de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports